import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { ControlGroup, ControlOption } from '../../../../components';
import { filterNonLegacy } from '../../../../../common/cpd-category-filter';

const CpdCategoryFilter = ({
  cpdCategories,
  selectedCpdCategory,
  clearAll,
  selectAll,
  changeHandler,
  show
}) => (
  <form
    id='cpd-category-filter'
    className={`slide-panel ${show === undefined ? 'hide' : ''} ${
      show ? 'in' : 'out'
    }`}
  >
    <Row className='no-gutter'>
      <Col md={6} xs={12} className='right-padding-md bottom-padding-sm'>
        <Button onClick={selectAll} className='full'>
          Select All
        </Button>
      </Col>
      <Col md={6} xs={12} className='right-padding-md'>
        <Button onClick={clearAll} className='full'>
          Clear All
        </Button>
      </Col>
    </Row>
    <Row className='no-gutter'>
      <ControlGroup
        control='checkbox'
        type='styled'
        label={null}
        colProps={{ xs: 12 }}
      >
        {fp.flow(
          filterNonLegacy,
          fp.sortBy(({ name }) => fp.lowerCase(name)),
          fp.map(({ id, name }) => (
            <ControlOption
              key={name}
              value={id}
              checked={fp.contains(id, selectedCpdCategory)}
              onChange={(e) => changeHandler(parseInt(e.target.value, 10))}
              label={<span>{he.decode(name)}</span>}
            />
          ))
        )(cpdCategories)}
      </ControlGroup>
    </Row>
  </form>
);

const mapStateToProps = (state) => ({
  cpdCategories: state.industry.cpdCategorys
});
const mapDispatchToProps = (dispatch) => ({});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    selectAll:
      ({ setAll, cpdCategories }) =>
      () => {
        setAll(
          fp.flow(
            filterNonLegacy,
            fp.map(({ id }) => id)
          )(cpdCategories)
        );
      },
    clearAll:
      ({ setAll }) =>
      () => {
        setAll([]);
      }
  })
)(CpdCategoryFilter);



// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/partials/cpd-category-filter.js